import { useEffect, useRef } from 'react'

import { EmailTemplateDetails } from 'core'

import { Col, Row } from 'common/components'

type Props = {
  loading: boolean
  selectedTemplate: EmailTemplateDetails
  contentToWrite: string
  isEditing: boolean
  onEdit: (templateId?: string, usingDefaultEditor?: boolean) => void
}

const EmailTemplateContent = ({ selectedTemplate, contentToWrite }: Props) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null)

  useEffect(() => {
    if (!selectedTemplate || !iframeRef.current) return

    const iframeDocument = iframeRef.current.contentDocument

    iframeDocument.write(contentToWrite)
    iframeDocument.close()

    const anchorTags = Array.from(iframeDocument.querySelectorAll('a'))
    anchorTags.forEach((anchor) => (anchor.href = 'javascript:void(0)'))

    return () => void (iframeDocument.body.innerHTML = '')
  }, [selectedTemplate, contentToWrite])

  if (!selectedTemplate) return null

  return (
    <Row>
      <Col className="w-100">
        <iframe ref={iframeRef} style={{ border: 0, width: '100%', height: '100vh' }} />
      </Col>
    </Row>
  )
}

export default EmailTemplateContent
